import { RESTORE_ALME_WINDOW } from './actionTypes'

export function restoreAlmeWindow(stateLocation)
{
    return {
        type : RESTORE_ALME_WINDOW,
        payload : {
            stateLocation
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-launch/src/actions/actions.js